import type { Cache, SWRConfiguration } from 'swr'

// SWR skips the refresh interval while a failed request leaves its error in the cache, so without a
// retry one failed poll stops polling until a reload. A polling hook retries at its own pace, up to
// its errorRetryCount (without limit when it sets none); a hook that does not poll, or whose cached
// data no longer asks for polling, is not retried
export const retryPollingOnError: SWRConfiguration['onErrorRetry'] = (
  _error,
  key,
  config,
  revalidate,
  { retryCount },
) => {
  // SWR passes its full config, cache included, but types the argument as the public part only
  const { refreshInterval, errorRetryCount, cache } = config as typeof config & { cache: Cache }
  // the data SWR itself passes to a refreshInterval function on every tick
  const pollingInterval =
    typeof refreshInterval === 'function' ? refreshInterval(cache.get(key)?.data) : refreshInterval

  if (!pollingInterval) return
  if (errorRetryCount !== undefined && retryCount > errorRetryCount) return

  setTimeout(revalidate, pollingInterval)
}
